import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CoreModule} from '../core.module';
import {SharedModule} from '../shared/shared.module';
import {PersonComponent} from './person.component';
import {PersonDetailComponent} from './person-detail/person-detail.component';
import {PersonModifyComponent} from './person-modify/person-modify.component';
import { AppointmentsComponent } from './person-modify/appointments/appointment-modify.component';
import {AddAppointmentComponent} from './person-modify/appointments/add-appointment/add-appointment.component';

@NgModule({
  imports: [
    CommonModule, CoreModule, SharedModule
  ],
  declarations: [
    PersonComponent,
    PersonDetailComponent,
    PersonModifyComponent,
    AppointmentsComponent,
    AddAppointmentComponent
  ],
  exports: [
    PersonComponent
  ]
})
export class PersonModule { }
